import {
  PROJECT_FLOW_MODE_QUERY_PARAM,
  ProjectFlowMode,
} from '@watershed/constants/projects';
import { useQueryParam } from '@watershed/shared-frontend/utils/queryParamHooks';

/**
 * Hook to manage the project creation flow query param state.
 * Used by both FlexibleProjectPageActions (to trigger) and FlexibleProjectsPage (to render dialog).
 */
export function useProjectCreationFlowState() {
  // Use query param for create dialog to enable leave prevention
  const [projectFlowMode, setProjectFlowMode] = useQueryParam(
    PROJECT_FLOW_MODE_QUERY_PARAM,
    { method: 'push', shallow: true }
  );

  const isCreateFlowOpen = projectFlowMode === ProjectFlowMode.Create;
  const closeCreateFlow = () => setProjectFlowMode(null);
  const openCreateFlow = () => setProjectFlowMode(ProjectFlowMode.Create);

  return { isCreateFlowOpen, openCreateFlow, closeCreateFlow };
}
